
export enum BadgeColors {
  BLUE='blue',
  PURPLE = 'purple',
  RED = 'red',
  YELLOW = 'yellow',
  GREY = 'grey',
  ORANGE = 'orange',
  DARKGREEN = 'darkgreen',
  GREEN = 'green'
}

